import Vue from 'vue';
import VueRouter from 'vue-router';

import paths from './app-routing';

import localStorage from '@/utility/localStorage';
import { APP_CONFIG } from '@/config/app-config';
import authService from '@/services/auth-services';
import store from '@/store/index';
import { eventBus } from '@/main';

Vue.use(VueRouter);
const router = new VueRouter({
    base: process.env.BASE_URL,
    mode: 'history',
    linkActiveClass: 'active',
    routes: paths
});

router.beforeEach(async (to, from, next) => {
    const resultAuth = await checkToken();
    if (to.matched.some((record) => record.meta.auth)) {
        if (resultAuth === false) {
            next({
                name: 'auth',
            });
        } else {
            next();
        }
    } else if (to.matched.some((record) => record.meta.noAuth)) {
        if (resultAuth === false) {
            next();
        } else {
            next({
                name: 'profile',
            });
        }
    } else {
        next();
    }

    if (screen.width <= 760) {
        (window['getApp'] as any).$emit('SHOW_HIDE_MENU_LEFT', false);
    }
});

async function checkToken() {
    if (!localStorage.exist(APP_CONFIG.authSetting.tokenName)) {
        return false;
    } else {
        const userInfo = (store.state as any)[APP_CONFIG.stateKey.authStore].userInfo;
        if (!userInfo || userInfo.userId <= 0) {
            const dataResult: any = await authService.verifyToken();
            if (dataResult && dataResult.data.hasOwnProperty('token') && dataResult.data.hasOwnProperty('user')) {
                eventBus.$emit(APP_CONFIG.eventBusAction.disableMenuLeft, false);
                eventBus.$emit(APP_CONFIG.eventBusAction.disableHeader, false);
                (window['getApp'] as any).$emit('APP_LOGIN_SUCCESS', dataResult.data, true);
                return true;
            }

            (window['getApp'] as any).$emit('APP_LOGOUT');
            return false;
        } else {
            return true;
        }
    }
}

export default router;
